const questions = [
]
export default {
  label:"Property Overview",
  link:"/property_overview",
  questions,
  tutorial_link:"http://xahlee.info/js/javascript_whats_property.html"
}



/** WEBPACK FOOTER **
 ** ./src/questions/03_properties/01_property_overview.js
 **/